import { render, staticRenderFns } from "./PdCreateInapp.vue?vue&type=template&id=b9b01b36&scoped=true&"
import script from "./PdCreateInapp.vue?vue&type=script&lang=ts&"
export * from "./PdCreateInapp.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9b01b36",
  null
  
)

export default component.exports